import './conversion-log.controller.scss';
import {IFilterService, IScope} from "angular";
import {ConversionLogPageParams} from "../model/ConversionLogPageParams";
import {ConversionLogFilter} from "../model/ConversionLogFilter";

interface ConversionLogControllerScope extends IScope {
    filter: ConversionLogFilter;
}

export class ConversionLogController {

    static instance = [
        '$scope',
        '$location',
        '$filter',
        ConversionLogController
    ];

    constructor(private $scope: ConversionLogControllerScope,
                private $location: ng.ILocationService,
                private $filter: IFilterService) {
    }

    $onInit() {
        this.$scope.filter = {
            branchNames: [],
            brandName: [],
            conversionTypes: [],
            campaignTypes: [],
            calculatorNames: []
        };
        this.bindUrlParameters();
        this.updateFromUrlParams();
    }


    private bindUrlParameters() {
        this.$scope.$on('$locationChangeSuccess', this.updateFromUrlParams);
        this.$scope.$watch('filter', this.updateUrlParams, true);
    }

    private updateFromUrlParams = () => {
        let search = <ConversionLogPageParams>this.$location.search();
        this.$scope.filter.startDate = new Date(search.startDate);
        this.$scope.filter.endDate = new Date(search.endDate);
    };

    private updateUrlParams = (newFilter: ConversionLogFilter) => {
        this.$location.search('startDate', this.getFormattedDate(newFilter.startDate));
        this.$location.search('endDate', this.getFormattedDate(newFilter.endDate));
    }

    private getFormattedDate(date): string {
        return this.$filter('date')(date, 'M/d/y');
    }

}